import * as React from 'react';
import {Query} from 'react-apollo';

import type {EmailMessage} from 'shells/email-row-item/types';

import type {
    GetEmailDetails as GetEmailDetailsQuery,
    GetEmailDetailsVariables as GetEmailDetailsQueryVariables,
    GetQueuedEmail as GetQueuedEmailQuery,
    GetQueuedEmailVariables as GetQueuedEmailQueryVeriables,
} from 'nutshell-graphql-types';

import GET_EMAIL from './graphql/queries/get-email-details.graphql';
import GET_QUEUED_EMAIL from './graphql/queries/get-queued-email.graphql';
import {
    mapFullEmailDetailsFragmentToEmailMessage,
    mapFullQueuedEmailDetailsFragmentToEmailMessage,
} from './utils';

class EmailQuery extends Query<GetEmailDetailsQuery, GetEmailDetailsQueryVariables> {}
class QueuedEmailQuery extends Query<GetQueuedEmailQuery, GetQueuedEmailQueryVeriables> {}

type Props = {
    emailId: string;
    isQueued: boolean;
    children: (arg1: {
        isLoading: boolean;
        emailMessage: EmailMessage | null | undefined;
        refetch: () => Promise<any>;
    }) => React.ReactElement;
};

/**
 * The representation of an email within a Nutshell Timeline.
 */
export function GetEmailDetails(props: Props) {
    const {isQueued, emailId, children} = props;

    if (isQueued) {
        return (
            <QueuedEmailQuery
                query={GET_QUEUED_EMAIL}
                variables={{queuedEmailId: emailId}}
                notifyOnNetworkStatusChange={true}
            >
                {({data, loading, refetch}) => {
                    const fullEmail = data && data.queuedEmail;
                    const emailMessage =
                        fullEmail && mapFullQueuedEmailDetailsFragmentToEmailMessage(fullEmail);

                    return children({emailMessage, isLoading: loading, refetch});
                }}
            </QueuedEmailQuery>
        );
    }

    return (
        <EmailQuery query={GET_EMAIL} variables={{emailId}} notifyOnNetworkStatusChange={true}>
            {({data, loading, refetch}) => {
                const fullEmail = data && data.email;
                const emailMessage =
                    fullEmail && mapFullEmailDetailsFragmentToEmailMessage(fullEmail);

                return children({emailMessage, isLoading: loading, refetch});
            }}
        </EmailQuery>
    );
}
